import { Navigate, useLocation } from "react-router-dom";
import { PageLoader } from "./Feedback";
import { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";

const ROLE_LABELS = { admin: "administrateurs", driver: "chauffeurs" };

export function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  const denied = !loading && user && role && user.role !== role;

  useEffect(() => {
    if (denied) {
      toast.error(`Accès réservé aux ${ROLE_LABELS[role] || role}`, {
        description: "Vous n'avez pas les droits nécessaires pour accéder à cette page.",
      });
    }
  }, [denied, role]);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <PageLoader label="Vérification de votre session…" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (denied) return <Navigate to="/" replace />;
  return children;
}
